import { render, staticRenderFns } from "./Extension.vue?vue&type=template&id=3d8f0ff0&scoped=true"
import script from "./Extension.vue?vue&type=script&lang=js"
export * from "./Extension.vue?vue&type=script&lang=js"
import style0 from "./Extension.vue?vue&type=style&index=0&id=3d8f0ff0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8f0ff0",
  null
  
)

export default component.exports